import React, { useEffect, useRef, useState } from "react";
import AccordionComponent from "../../../../common/Accordion";
import {
  Button,
  Col,
  Container,
  Form,
  InputGroup,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import TextInput from "../../../../common/TextInput";
import SearchableSingleSelectDropdown from "../../../../common/SearchableDropdown";
import MultilineTextBox from "../../../../common/MultilineTextBox";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/Store";
import {
  PARTY_TYPES,
  PICKLIST_GROUP_NAME,
  STAKEHOLDER_TYPE,
} from "../../../../common/Constant";
import { fetchPickListByGroupName } from "../../../../services/UserRegistrationApi";
import {
  AddStackHolderHeader,
  GetHeaderInfo,
  UpdateStackHolderHeader,
} from "../../../../services/StakeholderApi";
import { validateStakeholderHeaders } from "../../../Master/Stakeholders/components/stakeholderValidation";
import Snackbar from "../../../../common/Snackbar";
import StakeHolderTabs from "../../../Master/Stakeholders/components/StakeholderTabs";
import AddNewPartyAddress from "./AddNewPartyAddress";
import AddNewPartyContact from "./AddNewPartyContact";
import moment from "moment";
import OverlayDrawer from "../../../../common/OverlayDrawer";
import DataTable from "../../../../common/DataTable";
import { STAKEHOLDER_LOG_HEADERS } from "../../../Master/Stakeholders/actions/Constant";
import AddPartyPreference from "./AddPartyPreference";

interface PartyProps {
  partyTypes: any;
  setPartyID: any;
  setHasAddressData: any;
  setHasContactData: any;
  onBack: () => void;
}

const AddNewPartyClient: React.FC<PartyProps> = ({
  partyTypes,
  setPartyID,
  setHasAddressData,
  setHasContactData,
  onBack,
}) => {
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);

  const [entityName, setEntityName] = useState("");
  const [showEntityName, setShowEntityName] = useState("");
  const [partyOption, setPartyOption] = useState<
    { value: string; label: string }[]
  >([]);
  const [partyType, setPartyType] = useState<any>("");
  const [comments, setComments] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [activeKey, setActiveKey] = useState<string | null>("0");
  const [partyHeaderID, setPartyHeaderID] = useState<any>("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");

  const [selectedTab, setSelectedTab] = useState("Address");
  const [headerLogDetails, setHeaderLogDetails] = useState<any[]>([]);
  const [showLogDrawer, setShowLogDrawer] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [stakeholderLabelTypeId, setStakeholderLabelTypeId] = useState("");
  const [selectedStakeholderLabel, setSelectedStakeholderLabel] = useState<
    string | null
  >(null);

  const [selectedPartyType, setSelectedPartyType] = useState("");
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [uploadedFiles, setUploadedFiles] = useState<any[]>([]);
  const [isAddFiles, setIsAddFiles] = useState<boolean>(false);
  const [selectedImg, setSelectedImg] = useState<any>([]);
  const [fileInputValue, setFileInputValue] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const params = {
    parties: {
      groupName: PICKLIST_GROUP_NAME.Stakeholder_Types,
      triggerById: loggedInUserid,
    },
  };

  const fetchPartyOptionData = async () => {
    try {
      const partiesData = await fetchPickListByGroupName(params.parties);

      let filteredParties;
      if (partyTypes == PARTY_TYPES.CLIENT) {
        filteredParties = partiesData?.filter(
          (item: any) =>
            item.label === STAKEHOLDER_TYPE.QME_Doctor ||
            item.label === STAKEHOLDER_TYPE.PMC
        );
      } else if (partyTypes == PARTY_TYPES.Applicant_Attorney) {
        filteredParties = partiesData?.filter(
          (item: any) => item.label === STAKEHOLDER_TYPE.Applicant_Attorney
        );
      } else if (partyTypes == PARTY_TYPES.Défense_Attorney) {
        filteredParties = partiesData?.filter(
          (item: any) => item.label === STAKEHOLDER_TYPE.Défense_Attorney
        );
      }
      else if (partyTypes == PARTY_TYPES.Service_Provider) {
        filteredParties = partiesData?.filter(
          (item: any) => item.label === STAKEHOLDER_TYPE.Service_Provider
        );
      } else if (partyTypes == PARTY_TYPES.INSURANCE) {
        filteredParties = partiesData?.filter(
          (item: any) => item.label === STAKEHOLDER_TYPE.Insurance
        );
      } else if (partyTypes == PARTY_TYPES.EMPLOYER) {
        filteredParties = partiesData?.filter(
          (item: any) => item.label === STAKEHOLDER_TYPE.Employer
        );
      }
      setPartyOption(filteredParties || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchPartyHeaderData = async () => {
    try {
      const getPartyHeaderData = await GetHeaderInfo(Number(partyHeaderID));

      if (!getPartyHeaderData) return;
      setEntityName(getPartyHeaderData.result.entityname || "");
      setShowEntityName(getPartyHeaderData.result.entityname || "");
      setPartyHeaderID(String(getPartyHeaderData.result.stakeholderid));
      setPartyType(getPartyHeaderData.result.stakeholdertypeid);
      setStakeholderLabelTypeId(getPartyHeaderData.result.stakeholdertypeid);
      setComments(getPartyHeaderData.result.comments || "");
      setIsActive(getPartyHeaderData.result.isactive);

      const formattedCreatedDate = getPartyHeaderData.result.createddate
        ? moment(getPartyHeaderData.result.createddate).format(
          "MM/DD/YYYY HH:mm"
        )
        : "N/A";

      const formattedModifiedDate = getPartyHeaderData.result.modifieddate
        ? moment(getPartyHeaderData.result.modifieddate).format(
          "MM/DD/YYYY HH:mm"
        )
        : "N/A";

      setHeaderLogDetails([
        {
          createdby: getPartyHeaderData.result.createdbyname,
          createdon: formattedCreatedDate,
          modifiedby: getPartyHeaderData.result.modifiedbyname,
          modifiedon: formattedModifiedDate,
        },
      ]);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const handlePDFClick = () => {
    setShowTooltip(false);
    if (!partyHeaderID) return; // Ensure an address is selected

    setHeaderLogDetails(headerLogDetails); //

    setShowLogDrawer(true);
  };

  const handleCloseLogDrawer = () => {
    setShowLogDrawer(false);
  };

  useEffect(() => {
    fetchPartyOptionData();
  }, [loggedInUserid]);

  useEffect(() => {
    if (partyHeaderID) {
      fetchPartyHeaderData();
      setPartyID(partyHeaderID);
    }
  }, [partyHeaderID]);

  useEffect(() => {
    if (partyOption.length > 0 && stakeholderLabelTypeId) {
      const matchedOption = partyOption.find(
        (item) => item.value === stakeholderLabelTypeId
      );

      setSelectedStakeholderLabel(matchedOption ? matchedOption.label : null);
    }
  }, [stakeholderLabelTypeId]);

  const renderAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
        title:
          activeKey === index.toString() ? (
            item.title
          ) : (
            <>
              {item.title}
              <span className="fw-normal">
                {showEntityName ? ` - ${showEntityName} ` : ""}
              </span>
            </>
          ),
      }))}
      activeKey={activeKey}
      onSelect={(key) => setActiveKey(key as string)}
    />
  );

  const validateHeaderForm = () => {
    // Prepare values to pass for validation
    const validationErrors = validateStakeholderHeaders(entityName, partyType);

    // Call the validation function

    if (validationErrors.length > 0) {
      setSnackbarMessage(validationErrors.join("\n")); // Show error messages directly
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    const file = files[0];
    setIsAddFiles(false);
    if (!file.type.startsWith("image/")) {
      setSnackbarMessage("Please select only image file");
      setError("error");
      setSnackbarOpen(true);
      return;
    }

    const maxSize = 100 * 1024 * 1024;
    if (file.size > maxSize) {
      setSnackbarMessage("File size must be less than 100MB");
      setError("error");
      setSnackbarOpen(true);
      return;
    }
    setSelectedImg(file);
    setFileInputValue(file.name);

    if (event.target) {
      event.target.value = "";
    }
  };

  const handleAddFile = () => {
    const file = selectedImg;
    const previewUrl = URL.createObjectURL(file);
    const newFile = {
      file,
      previewUrl,
      name: file.name,
      size: file.size,
      type: file.type,
    };

    setUploadedFiles([newFile]);
    setIsAddFiles(true);
  };

  const handleRemoveFile = (index: number) => {
    if (uploadedFiles[index].previewUrl) {
      URL.revokeObjectURL(uploadedFiles[index].previewUrl);
    }

    const newFiles = uploadedFiles.filter((_, i) => i !== index);
    setUploadedFiles(newFiles);
    setFileInputValue(newFiles.map((file) => file.name).join(", "));
    setSelectedImg([]);
    if (newFiles.length === 0 && fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.classList.remove("drag-over");

    const files = Array.from(event.dataTransfer.files);
    if (files.length > 0) {
      const syntheticEvent = {
        target: { files: event.dataTransfer.files },
      } as React.ChangeEvent<HTMLInputElement>;
      handleFileChange(syntheticEvent);
    }
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.classList.add("drag-over");
  };

  const handleDragLeave = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.classList.remove("drag-over");
  };

  // Clean up object URLs when component unmounts
  useEffect(() => {
    return () => {
      uploadedFiles.forEach((file) => {
        if (file.previewUrl) {
          URL.revokeObjectURL(file.previewUrl);
        }
      });
    };
  }, [uploadedFiles]);

  const addParty = async () => {
    if (isSaving) return;
    if (validateHeaderForm()) {
      try {
        setIsSaving(true);
        const headerPayload = {
          stakeholderId: partyHeaderID ? partyHeaderID : null,
          entityName: entityName,
          stakeholderTypeId: Number(partyType),
          comments: comments,
          isActive: isActive ? 1 : 0, // Convert boolean to 1/0
          createdBy: Number(loggedInUserid),
        };

        const isUpdate = partyHeaderID ? true : false;

        const formData = new FormData();

        // Append all data as form fields
        formData.append("EntityName", entityName);
        formData.append("StakeholderTypeId", String(partyType));
        formData.append("Comments", comments);
        formData.append("IsActive", isActive ? "1" : "0");
        formData.append("CreatedBy", String(loggedInUserid));

        if (partyHeaderID) {
          formData.append("StakeholderId", String(partyHeaderID));
        }

        // Append the file if a new one was uploaded
        if (selectedImg && selectedImg instanceof File) {
          formData.append("File", selectedImg);
        } else if (uploadedFiles?.length > 0 && uploadedFiles[0]?.file) {
          // If file is already in uploadedFiles
          formData.append("File", uploadedFiles[0].file);
        }

        const apiMethod = isUpdate
          ? UpdateStackHolderHeader
          : AddStackHolderHeader;

        const response = await apiMethod(formData);

        if (response.isSuccess) {
          if (response.result.responseCode == 1) {
            setPartyHeaderID(response.result.id);

            const successMessage = isUpdate
              ? "Party details updated successfully!"
              : "Party header details saved successfully!";

            setSnackbarMessage(successMessage);
            setError("success");
            setSnackbarOpen(true);

            fetchPartyHeaderData();
            setActiveKey(null);
          } else {
            setSnackbarMessage("Entity name should be unique");
            setError("error");
            setSnackbarOpen(true);
          }
        }
      } catch (error) {
        setSnackbarMessage(
          "An error occurred while saving contact details. Please try again."
        );
        setError("error");
        setSnackbarOpen(true);
        console.error("Error during API call:", error);
      } finally {
        setIsSaving(false);
      }
    }
  };

  const handleCancel = async () => {
    if (partyHeaderID) {
      await fetchPartyHeaderData();
    } else {
      setEntityName("");
      setShowEntityName("");

      setPartyType("");
      setComments("");
      setIsActive(true);
    } // Re-fetch and update state with original values
  };

  const [isPreferenceNeeded, setIsPreferenceNeeded] = useState(false);
  useEffect(() => {
    if (partyTypes == PARTY_TYPES.CLIENT) {
      setIsPreferenceNeeded(true);
    }
  }, [partyTypes]);
  return (
    <>
      <Container fluid className="px-3 d-flex flex-column min-vh-95">
        <Snackbar
          open={snackbarOpen}
          message={snackbarMessage}
          onClose={() => setSnackbarOpen(false)}
          severity={error}
        />

        <div>
          {renderAccordion([
            {
              title: "Header",
              content: (
                <div>
                  <Row>
                    <Col sm={9}>
                      <TextInput
                        label="Entity Name"
                        name="entityName"
                        required
                        value={entityName}
                        maxLength={100}
                        onChange={(e) => {
                          setEntityName(e.target.value);
                        }}
                      />
                    </Col>
                    <Col sm={3} className="selection_dropdown">
                      <SearchableSingleSelectDropdown
                        label="Party Type"
                        name="stakeholderTypeId"
                        required
                        options={partyOption}
                        value={partyType}
                        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                          setPartyType(e.target.value);
                          const selectedOption = partyOption.find(
                            (opt) => opt.value === e.target.value
                          );
                          setSelectedPartyType(selectedOption?.label || "");
                        }}
                      />
                    </Col>
                    <Col sm={12} className="mt-4">
                      <MultilineTextBox
                        label="Comments"
                        name="comments"
                        value={comments}
                        maxLength={1000}
                        onChange={(e) => setComments(e.target.value)}
                      />
                    </Col>
                    <div className="mt-3">
                      {selectedPartyType === STAKEHOLDER_TYPE.PMC &&
                        renderAccordion([
                          {
                            title: "Logo Attachment",
                            content: (
                              <div className="row">
                                <div className="col-md-8 col-xl-9">
                                  <Form.Group className="mb-0">
                                    <div className="d-flex align-items-center">
                                      <Form.Control
                                        type="file"
                                        ref={fileInputRef}
                                        accept="image/*"
                                        multiple={false}
                                        onChange={handleFileChange}
                                        style={{ display: "none" }}
                                      />
                                      <div
                                        className="file-drop-zone flex-grow-1"
                                        onClick={() =>
                                          fileInputRef.current?.click()
                                        }
                                        onDragOver={handleDragOver}
                                        onDragLeave={handleDragLeave}
                                        onDrop={handleDrop}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <InputGroup>
                                          <Form.Control
                                            type="text"
                                            placeholder="Choose an image or drag it here"
                                            value={fileInputValue}
                                            readOnly
                                            className="border-end-0"
                                            style={{
                                              cursor: "pointer",
                                              height: "45px",
                                            }}
                                          />
                                          <Button
                                            variant="outline-secondary"
                                            className="p-0 border-start-0 attachbtn d-flex align-items-center"
                                            onClick={(e) => e.preventDefault()}
                                          >
                                            <span className="material-symbols-outlined color_brand mx-1">
                                              attach_file
                                            </span>
                                          </Button>
                                        </InputGroup>
                                      </div>

                                      <Button
                                        className="btn btn-primary d-flex align-items-center justify-content-center ms-2"
                                        onClick={handleAddFile}
                                        disabled={selectedImg.length === 0}
                                        style={{
                                          height: "45px",
                                          minWidth: "70px",
                                        }}
                                      >
                                        <span className="material-symbols-outlined me-1 d-flex align-items-center">
                                          add_circle
                                        </span>
                                        Add
                                      </Button>
                                    </div>
                                  </Form.Group>
                                </div>

                                <div className="col-md-4 col-xl-3 borderLSide">
                                  {uploadedFiles?.length > 0 ? (
                                    <div
                                      className="logo-preview border rounded p-2 bg-white w-100"
                                      style={{
                                        width: "200px",
                                        textAlign: "center",
                                      }}
                                    >
                                      <img
                                        src={uploadedFiles[0].previewUrl}
                                        alt={uploadedFiles[0].name}
                                        className="img-fluid"
                                        style={{
                                          maxHeight: "80px",
                                          objectFit: "contain",
                                        }}
                                      />

                                      <Button
                                        variant="danger"
                                        size="sm"
                                        className="attchmentClose"
                                        style={{
                                          width: "24px",
                                          height: "24px",
                                          borderRadius: "50%",
                                          padding: "0",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                        onClick={() => handleRemoveFile(0)}
                                      >
                                        <span
                                          className="material-symbols-outlined"
                                          style={{ fontSize: "14px" }}
                                        >
                                          close
                                        </span>
                                      </Button>
                                    </div>
                                  ) : (
                                    <>
                                      <div className="logo-preview border rounded p-2 bg-white w-100 noPreview">
                                        <span className="material-symbols-outlined iconDesign">
                                          add_a_photo
                                        </span>{" "}
                                        <span className="logoPreviewrNote">
                                          Logo Preview
                                        </span>
                                      </div>
                                      <span className="noteHeadline">
                                        {" "}
                                        Supported formats:{" "}
                                        <strong>JPG, PNG</strong> — Maximum file
                                        size: <strong>1000 MB</strong>
                                      </span>
                                    </>
                                  )}
                                </div>
                              </div>
                            ),
                          },
                        ])}
                    </div>
                    <div className="mt-3">
                      <label htmlFor="isActive" className="me-2 fw-bold">
                        Is Active
                      </label>
                      <input
                        type="checkbox"
                        id="isActive"
                        className="me-2"
                        checked={isActive}
                        onChange={(e) => setIsActive(e.target.checked)}
                        disabled={!partyHeaderID}
                      />
                    </div>
                  </Row>

                  <hr />

                  <Row>
                    <Col md={6} className="d-flex justify-content-start">
                      <Button
                        variant="outline"
                        className="btn d-flex align-items-center btn-text-border"
                        onClick={onBack}
                      >
                        <span className="material-icons me-1">arrow_back</span>
                        Back
                      </Button>
                      {partyHeaderID ? (
                        <OverlayTrigger
                          show={showTooltip}
                          placement="auto"
                          trigger={["hover", "focus"]}
                          delay={{ show: 200, hide: 100 }}
                          overlay={
                            <Tooltip style={{ backgroundColor: "#b3e0ff" }}>
                              Logs
                            </Tooltip>
                          }
                        >
                          <button
                            type="button"
                            className="btn btn-primary d-flex align-items-center mx-2"
                            onClick={handlePDFClick}
                            onMouseEnter={() => setShowTooltip(true)}
                            onMouseLeave={() => setShowTooltip(false)}
                          >
                            <span className="material-icons">description</span>
                          </button>
                        </OverlayTrigger>
                      ) : null}
                    </Col>
                    <Col className="d-flex justify-content-end mb-2">
                      <Button
                        variant="outline-info"
                        className="d-flex align-items-center"
                        onClick={handleCancel}
                      >
                        <span className="material-icons me-2">close</span>{" "}
                        Cancel
                      </Button>
                      <Button
                        variant="primary"
                        className="ms-3 d-flex align-items-center"
                        onClick={addParty}
                        disabled={isSaving}
                      >
                        <span className="material-icons me-1">save</span> Save
                      </Button>
                    </Col>
                  </Row>
                  <OverlayDrawer
                    title={"Logs"}
                    open={showLogDrawer}
                    onClose={handleCloseLogDrawer}
                    placement="bottom"
                  >
                    <DataTable
                      headers={STAKEHOLDER_LOG_HEADERS}
                      rows={headerLogDetails}
                      isLogTable={true}
                    />
                  </OverlayDrawer>
                </div>
              ),
            },
          ])}

          {partyHeaderID ? (
            <>
              <StakeHolderTabs
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab}
                showPreferenceTab={isPreferenceNeeded}
              />

              {selectedTab === "Address" && (
                <AddNewPartyAddress
                  partyID={partyHeaderID}
                  setHasAddressData={setHasAddressData}
                  onBack={onBack}
                />
              )}

              {selectedTab === "Contacts" && (
                <AddNewPartyContact
                  partyID={partyHeaderID}
                  partyType={partyTypes}
                  partyTypeID={partyType}
                  setHasContactData={setHasContactData}
                  StakeholderLabel={selectedStakeholderLabel}
                  onBack={onBack}
                />
              )}

              {isPreferenceNeeded && selectedTab === "Preferences" && (
                <AddPartyPreference
                  userData={partyHeaderID}
                  onCancel={onBack}
                />
              )}
            </>
          ) : null}
        </div>
      </Container>
    </>
  );
};

export default AddNewPartyClient;
